// shared/hooks/useSearchAttachments.js
import { useCallback } from 'react';
import { searchAttachments } from '../data/searchAttachments';

export function useSearchAttachments() {
  return useCallback(async (params) => {
    try {
      return await searchAttachments(params);
    } catch (err) {
      console.log('ATTACHMENT SEARCH FAILED');
      throw err;
    }
  }, []);
}
